<template>
  <div class="platform-box" ref="myElementRef">
    <el-alert
      class="tip-bar"
      type="info"
      :closable="false"
      :title="t('platformLogs.tip')"
    />
    <div ref="searchBox">
      <hc-search :data="searchData" @serch="getSearch" />
    </div>

    <hc-table
      :tableData="state.tableData"
      :column="state.tableHeader"
      :offsetHeight="state.offsetHeight"
      :maxPage="maxPage"
      @pageChange="pageChange"
      @limitChange="limitChange"
    >
      <template #event_type="{ row }">
        <el-tag :type="row.event_type == 1 ? 'success' : 'primary'" size="small">
          {{ row.event_type == 1 ? t('platformLogs.eventOpen') : t('platformLogs.eventRenew') }}
        </el-tag>
      </template>
      <template #subscription_years="{ row }">
        {{ row.subscription_years > 0 ? row.subscription_years + t('platformLogs.yearSuffix') : (row.remark || t('platformLogs.monthly')) }}
      </template>
      <template #opened_at="{ row }">{{ formatDate(row.opened_at) }}</template>
      <template #expire_at_before="{ row }">{{ formatDate(row.expire_at_before) }}</template>
      <template #expire_at_after="{ row }">{{ formatDate(row.expire_at_after) }}</template>
      <template #created_at="{ row }">{{ formatDate(row.created_at) }}</template>
    </hc-table>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from 'vue'
import hcSearch from '@/components/hc-search/index.vue'
import hcTable from '@/components/hc-table/index.vue'
import { tenantSubscriptionLogListApi } from '@/api/platform/tenants'
import { ElMessage } from 'element-plus'
import { usePageI18n } from '@/composables/usePageI18n.js'
import { applySearchLabels, applyColumnLabels } from '@/utils/listPageI18n.js'

const LOG_COLUMNS = {
  tenant_code: 'platformLogs.colTenantCode',
  tenant_name: 'platformLogs.colTenantName',
  event_type: 'platformLogs.colEventType',
  subscription_years: 'platformLogs.colYears',
  opened_at: 'platformLogs.colOpenedAt',
  expire_at_before: 'platformLogs.colExpireBefore',
  expire_at_after: 'platformLogs.colExpireAfter',
  operator_username: 'platformLogs.colOperator',
  remark: 'platformLogs.colRemark',
  created_at: 'platformLogs.colCreatedAt',
}

const myElementRef = ref()
const searchBox = ref()
const maxPage = ref(0)
const page = ref(1)
const limit = ref(20)

const searchData = reactive([
  { label: '关键词', type: 'input', value: '', field: 'keywords', placeholder: '租户码/名称/操作人' }
])

const state = reactive({
  offsetHeight: 0,
  tableData: [],
  tableHeader: [],
  column: [
    { type: 'index', label: '序号', width: 70, show: true },
    { prop: 'tenant_code', label: '租户码', width: 100, show: true },
    { prop: 'tenant_name', label: '租户名称', width: 120, show: true },
    { prop: 'event_type', label: '类型', width: 80, show: true },
    { prop: 'subscription_years', label: '年限', width: 70, show: true },
    { prop: 'opened_at', label: '起算时间', width: 155, show: true },
    { prop: 'expire_at_before', label: '变更前到期', width: 155, show: true },
    { prop: 'expire_at_after', label: '变更后到期', width: 155, show: true },
    { prop: 'operator_username', label: '操作人', width: 100, show: true },
    { prop: 'remark', label: '备注', width: 120, show: true },
    { prop: 'created_at', label: '操作时间', width: 155, show: true }
  ]
})

const formatDate = (val) => {
  if (!val) return '—'
  const s = String(val)
  return s.length >= 16 ? s.substring(0, 16) : s
}

const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => v.show)
}

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight = myElementRef.value.offsetHeight - 120 - (searchBox.value?.offsetHeight || 0)
  }
}

const getSearch = (params) => {
  tenantSubscriptionLogListApi({
    page: page.value,
    limit: limit.value,
    keywords: params?.keywords ?? searchData[0].value ?? ''
  }).then((res) => {
    if (res.code === 200) {
      state.tableData = res.data || []
      maxPage.value = res.maxPage || 0
    } else {
      ElMessage.error(res.msg || t('platformLogs.loadFailed'))
    }
  })
}

const pageChange = (p) => {
  page.value = p
  getSearch(searchData)
}

const limitChange = (l) => {
  limit.value = l
  getSearch(searchData)
}

const applyLabels = () => {
  applySearchLabels(searchData, {
    keywords: { labelKey: 'platformRenewal.keywords', placeholderKey: 'platformLogs.keywordsPh' },
  })
  applyColumnLabels(state.column, LOG_COLUMNS)
  tableHeaderFn()
}
const { t } = usePageI18n(applyLabels)
applyLabels()

onMounted(() => {
  nextTick(() => offHeighths())
  window.onresize = () => nextTick(() => offHeighths())
  tableHeaderFn()
  getSearch(searchData)
})
</script>

<style scoped lang="less">
.platform-box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.tip-bar {
  margin-bottom: 12px;
}
</style>
